import { IBaseCellsProps } from '../../cells.interfaces';
import { StyledTableCell } from '../../CellCheckbox/CellCheckbox.styles';
import { Skeleton } from '../../../../base-components';

const CellIconSkeleton = (props: IBaseCellsProps) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
    } = props;
    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
            isHeaderCell={false}
        >
            <Skeleton variant="rectangular" width={5} height={5} />
        </StyledTableCell>
    );
};

export default CellIconSkeleton;
